<script lang="ts" setup>
  import { Button } from '../../../../shared/ui/button';
</script>

<template>
  <Button appearance="spotify">
    <template #icon>
      <img alt="" src="/src/assets/spotify-logo.png" />
    </template>
    <slot />
  </Button>
</template>
